// src/api/supplierApi.js
import axiosClient from "./axiosClient";

const supplierApi = {
  getSupplier: () => {
    return axiosClient.get(`/supplier/getSupplier`, {
      withCredentials: true,
    });
  },
  upsertSupplier: (data) => {
    return axiosClient.post(`/supplier/upsertSupplier`, data, {
      withCredentials: true,
    });
  },
  deleteSupplier: (id) => {
    return axiosClient.delete(`/supplier/${id}`, {
      withCredentials: true,
    });
  },
};

export default supplierApi;
